<template>

    <div class="key-pad-wrapper">

        <div class="number-button" v-for=" n in 12 " :key=" n ">

            <p class="the-number" @click=" selectNumber( n ) ">

                {{ n == 10 ? 'clr' : n == 11 ? '0' : n == 12 ? '<=' : n }}
            </p>
        </div>
    </div>
</template>

<script>

    export default {

        name: 'key-pad',
        data: function() {

            return {

            }
        },
        methods: {

            selectNumber( input ){

                let data;
                switch( input ){

                    case 10: // do nothing

                        data = {

                            number    : null,
                            direction : 'clear'
                        };
                        break;
                    case 11: // this is zero

                        data = {

                            number    : 0,
                            direction : 'forwards'
                        };
                        break;
                    case 12: // this is the back key
                    case "Backspace":

                        data = {

                            number    : null,
                            direction : 'backwards'
                        };
                        break;
                    default: // take input as is

                        data = {

                            number    : input,
                            direction : 'forwards'
                        };
                        break;
                }
                if( data !== null ) this.$store.dispatch( 'keypad/changePosition', data );
            },
            keypressHandler( e ){

                this.selectNumber( e.key );
            }
        },
        created () {

            window.addEventListener( 'keydown', this.keypressHandler );
        },
        destroyed () {

            window.removeEventListener( 'keydown', this.keypressHandler );
        },
    }
</script>

<style scoped>

    .key-pad-wrapper {

        display: flex;
        flex-wrap: wrap;
        /* background: rgb(77,186,128); */
        /* background: radial-gradient(circle, rgba(77,186,128,1) 0%, rgba(0,0,0,1) 100%); */
        border-radius: 3px;
    }
    .number-button {

        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        flex: 1;
        min-width: 33.33%;
        max-width: 33.33%;
        height: 70px;
    }
    .the-number {

        background-color: rgba( 255, 255, 255, 0.9 );
        box-shadow: 0px 3px 2px 1px rgb( 77, 186, 128 );
        position: relative;
        width: 75%;
        height: 75%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
    }
    .the-number:active {

        top: 1px;
    }
</style>